import React, { Component } from 'react';
//import NewDropSelector from './../../../../commons/NewDropSelector.js';
import ExpDropSelector from './../../../../commons/ExpDropSelector.js';
// import DateSelector from './../../../../commons/DateSelector.js';
import Checkbox from '@material-ui/core/Checkbox';
import JobsOperationsApiHandler from './../../JobsOperationsApiHandler.js';
import CircularProgress from '@material-ui/core/CircularProgress';
// import Dialog from '@material-ui/core/Dialog';
import ErrorBox from './../../../../commons/ErrorBox';
// import Tick from './../../../../assets/img/tick.png'



const datefor = new Intl.DateTimeFormat('en-GB', {
	year: 'numeric',
	month: 'short',
	day: '2-digit'
});

export default class ItemWisePick extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentSlot: 1,
			selectedDate: null,
			generatedSlots: null,
			showloader: false,
			priority: false,
			createPickLoader: false,
			jobCreated: false,
			creationActivity: null,
			oldJobActivity: null,
			users: [],
			// reassignmentOpen: false,
			// selectedUsersForReassignment: [],
			// allChecked: false,
			selectedUsersForAssignment: [],
			jobsAssigningLoader: false,
			selectUsersOption: false,
			// reassignmentConfirmation: false,
			// reassignmentLoading: false,
			// showReassignSuccessScreen: false,
			checkingStatus: false,
			error: null,
			selectedCustomerGroup: null,
			selectedProductTypes: null,
			selectedEquipmentType: null,
			canAddNewSlot: false,
			addedNewSlot: false,
			checkStatusDisabled: false,
			showAllUsers: false,
			loadFetchUsers: false
		};
		// this.openReassignment = this.openReassignment.bind(this);
		// this.reassignmentDialogClose = this.reassignmentDialogClose.bind(this);
		this.selectUsers = this.selectUsers.bind(this);
		this.handleUserSelection = this.handleUserSelection.bind(this);
		this.assignJobs = this.assignJobs.bind(this);
		this.retryAgain = this.retryAgain.bind(this);
		this.selectUsersToAssign = this.selectUsersToAssign.bind(this);
		this.assignmentComplete = this.assignmentComplete.bind(this);
		this.closeError = this.closeError.bind(this);
		// this.askForReassignmentConfirmation = this.askForReassignmentConfirmation.bind(this);
		// this.reassignmentConfirmationClose = this.reassignmentConfirmationClose.bind(this);
		// this.closeSuccessScreen = this.closeSuccessScreen.bind(this);
		// this.proceedReassignment = this.proceedReassignment.bind(this);
		this.addNewSlot = this.addNewSlot.bind(this);
		this.cancelCurrentSlot = this.cancelCurrentSlot.bind(this);
	}


	closeError() {
		this.setState({ error: null });
	}


	//<!------------------------------------- Fetch Users For Role PICKING -------------------------------------!>
	fetchUser = (showAllUsers) => {
		//showAllUsers === true : get all users ? get users for that facility

		this.setState({ loadFetchUsers: true });
		JobsOperationsApiHandler.getFcUsersForProcessType('PICKING', showAllUsers)
			.then(resp => {
				resp.sort(function (a, b) { return (a.displayName > b.displayName) ? 1 : ((b.displayName > a.displayName) ? -1 : 0); });
				this.setState({ users: resp });
			}).catch(error => {

			}).finally(() => {
				this.setState({ loadFetchUsers: false });
			})

	}

	//<!------------------------------------- Component Did Mount -------------------------------------!>
	componentDidMount() {
		let selectedFacility = JSON.parse(localStorage.getItem('selectedFacility'));
		if (selectedFacility.facilityName !== "Sutlej/Gomati") {
			this.setState({
				selectedCustomerGroup: 'GENERAL'
			})
		}
		this.setState({ selectedDate: this.props.selectedDate });
		this.fetchUser(false);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.selectedDate !== this.state.selectedDate) {
			this.setState({ selectedDate: nextProps.selectedDate, addedNewSlot: false }, function () {
				this.dateSelected();
			});
		}
	}


	//<!------------------------------------- Getting dates to for dropdown -------------------------------------!>
	// dates() {
	// 	var dates = [];
	// 	var todayDate = new Date();
	// 	todayDate.setHours(0, 0, 0, 0);
	// 	var dateMillis = Date.parse(todayDate);
	// 	for(var i = 0 ; i < 3 ; i++ ) {
	// 		var obj = {
	// 			deliveryDate : datefor.format(dateMillis),
	// 			epochTime: dateMillis
	// 		};
	// 		dates.push(obj);
	// 		dateMillis += 86400000;
	// 	}
	// 	return dates;
	// }

	//<!------------------------------------- Sorting Generaed Slots -------------------------------------!>
	generatedSlots(obj) {
		var currentSlot = 1;
		//var generated = Object.keys(obj).map((key)=>{return {Slot:String(key), Status:(obj)[key]}});
		if (obj.length > 0) {
			var last = obj[obj.length - 1];
			if (last.activityStatus === 'GENERATED' && last.activityType === 'JOB_CREATION') {
				this.setState({ jobCreated: false, creationActivity: null });
				currentSlot = obj.length + 1;
			} else {
				this.setState({ creationActivity: last, jobCreated: true });
				obj.splice(obj.length - 1, 1);
				currentSlot = last.slotId;
				this.setState({ addedNewSlot: true })
			}
		} else {
			this.setState({ jobCreated: false, creationActivity: null });
		}
		this.setState({ generatedSlots: obj, currentSlot: currentSlot });
	}

	//<!------------------------------------- Checking activity status (Server Call)-------------------------------------!>
	checkActivityStatus = () => {
		this.setState({ checkingStatus: true, checkStatusDisabled: true });
		var activityId = this.state.creationActivity.jobActivityId;
		JobsOperationsApiHandler.getJobCreationSTatus(activityId)
			.then(function (resp) {
				this.setState({ creationActivity: resp });
				if (resp.activityStatus !== "FAILED") {
					this.setState({ checkStatusDisabled: false })
				}
			}.bind(this)).catch(function (error) {
				console.log(error);
			}).finally(function () {
				this.setState({ checkingStatus: false });
			}.bind(this))
	}

	//<!------------------------------------- Date Selection and fetching Generaed Slots (Server Call)-------------------------------------!>
	dateSelected = () => {
		var st = this.state;
		if (this.props.selectedDate && st.selectedCustomerGroup && st.selectedEquipmentType) {
			if (this.props.productTypes && !st.selectedProductTypes) {
				return;
			} else {
				if (this.props.spaceTypes && this.props.spaceTypes.length > 0 && !st.selectedSpaceType) {
					return;
				}
				this.setState({ showloader: true, addedNewSlot: false });
				var req = {
					deliveryDate: this.props.selectedDate.epochTime,
					processPhase: this.props.processPhase,
					customerType: st.selectedCustomerGroup,
					equipmentType: st.selectedEquipmentType,
					productType: st.selectedProductTypes
				}
				if (this.props.spaceTypes && this.props.spaceTypes.length > 0) {
					req.pickZoneId = st.selectedSpaceType.spaceId;
				}
				JobsOperationsApiHandler.getSlotProcessingStatus(req)
					.then((resp) => {
						this.generatedSlots(resp);
						this.setState({ canAddNewSlot: true });
					}).catch((error) => {
						this.setState({ error: error.error.error });
					}).finally(() => {
						this.setState({ showloader: false, selectedDate: this.props.selectedDate });
					})
			}
		}
	}

	//<!------------------------------------- Creating Job Request (Server Call)-------------------------------------!>	
	createJobRequest = () => {
		this.setState({ createPickLoader: true, checkStatusDisabled: false });
		var request = {
			slotId: this.state.currentSlot,
			deliveryDate: this.state.selectedDate.epochTime,
			processPhase: this.props.processPhase,
			customerType: this.state.selectedCustomerGroup,
			equipmentType: this.state.selectedEquipmentType,
			productType: this.state.selectedProductTypes
		};
		if (this.props.spaceTypes && this.props.spaceTypes.length > 0) {
			request.floorSpaceIds = [this.state.selectedSpaceType.spaceId];
		}
		JobsOperationsApiHandler.createPickJob(request)
			.then((resp) => {
				this.setState({ creationActivity: resp, jobCreated: true });
			}).catch((error) => {
				this.setState({ error: error.error.error });
			}).finally(() => {
				this.setState({ createPickLoader: false });
			});
	}


	//<!------------------------------------- Assign Jobs (Server Call)-------------------------------------!>	
	assignJobs() {
		if (this.state.jobsAssigningLoader) {
			return;
		}
		this.setState({ jobsAssigningLoader: true });
		var request = {
			jobActivityId: this.state.oldJobActivity.jobActivityId,
			// slotId :this.state.currentSlot,
			// promiseDayForDelivery : this.state.selectedDate.epochTime,
			// processPhase: this.props.processPhase,
			users: this.state.selectedUsersForAssignment
		};
		JobsOperationsApiHandler.assignUsersAndGeneratePickJob(request)
			.then((resp) => {
				this.setState({ jobCreated: true, creationActivity: resp, selectUsersOption: false });
			}).catch((error) => {
				this.setState({ error: error.error.error });
			}).finally(() => {
				this.setState({ jobsAssigningLoader: false });
			});
	}

	//<!------------------------------------- Handling Priority Customer CheckBox -------------------------------------!>
	handlePriority = () => {
		var pri = !this.state.priority;
		this.setState({ priority: pri });
		if (this.state.selectedDate) {
			this.setState({ showloader: true });
			var req = {
				deliveryDate: this.state.selectedDate.epochTime,
				processPhase: this.props.processPhase,
				customerType: pri ? 'PRIORITY' : 'GENERAL'
			}
			JobsOperationsApiHandler.getSlotProcessingStatus(req)
				.then((resp) => {
					this.generatedSlots(resp);
				}).catch((error) => {
					this.setState({ error: error.error.error });
				}).finally(() => {
					this.setState({ showloader: false });
				})
		}

	}

	//<!------------------------------------- Get Logs To Show Render Method (UI Render)-------------------------------------!>
	getLogsRender() {
		var logs;
		if (this.state.creationActivity) {
			if (this.state.creationActivity.jobLogs) {
				logs = this.state.creationActivity.jobLogs.map((log, index) => {
					return (
						<div className={"JOB-LOGS " + (log.logMessageType)} key={index}>
							# {log.message.substr(0, 400)}
						</div>
					);
				})
			} else {
				if (this.state.creationActivity.activityType === 'IMR_CREATION') {
					logs = <div>IMR Generation Request submitted successfully. Click on Check Status button for seeing the progress.</div>;
				} else {
					logs = <div>User Assignment Request submitted successfully. Click on Check Status button for seeing the progress.</div>;
				}
			}
		}
		return logs;
	}

	//<!------------------------------------- Closing Reassignment Dialoge -------------------------------------!>
	// reassignmentDialogClose() {
	// 	this.setState({reassignmentOpen: false});
	// }

	//<!------------------------------------- Opening Reassignment Dialoge -------------------------------------!>
	// openReassignment() {
	// 	this.setState({reassignmentOpen: true});
	// }

	// askForReassignmentConfirmation() {
	// 	this.setState({reassignmentConfirmation: true, reassignmentOpen: false});
	// }

	// reassignmentConfirmationClose() {
	// 	this.setState({reassignmentConfirmation: false});
	// }

	// proceedReassignment() {
	// 	if(this.state.reassignmentLoading) {
	// 		return;
	// 	}
	// 	this.setState({reassignmentConfirmation: false, reassignmentOpen: true, reassignmentLoading: true});
	// 	var request = {
	// 		deliveryDate: this.state.selectedDate.epochTime,
	// 		needsEquipmentForJob: 0,
	// 		processPhase: this.props.processPhase,
	// 		userIds: this.state.selectedUsersForReassignment
	// 	};
	// 	JobsOperationsApiHandler.reassignPickJobs(request)
	// 	.then((resp) => {
	// 		this.setState({reassignmentOpen: false, showReassignSuccessScreen: true});
	// 	}).catch((error) => {
	// 		this.setState({error: error.error.error});
	// 	}).finally(() => {
	// 		this.setState({reassignmentLoading: false});
	// 	});

	// }

	// closeSuccessScreen() {
	// 	this.setState({showReassignSuccessScreen: false});
	// }
	// //<!------------------------------------- Adding a user for Reassignment -------------------------------------!>
	// handleHeroCheckBox(hero) {
	// 	var selected  = this.state.selectedUsersForReassignment;
	// 	if(hero.checkedVal) {
	// 		for(var i in selected) {
	// 			if(selected[i] === hero.naturalId) {
	// 				selected.splice(i, 1);
	// 				break;
	// 			}
	// 		}
	// 		hero.checkedVal = false;
	// 		this.setState({selectedUsersForReassignment: selected, allChecked: false})
	// 	} else {
	// 		selected.push(hero.naturalId);
	// 		hero.checkedVal = true;
	// 		this.setState({selectedUsersForReassignment: selected})
	// 	}	
	// }

	// //<!------------------------------------- Handling all user adding for reassignment -------------------------------------!>
	// handleAllCheck() {
	// 	var allUsers = this.state.users;
	// 	if(this.state.allChecked) {
	// 		for(var i in allUsers) {
	// 			allUsers[i].checkedVal = false;
	// 		}
	// 		this.setState({allChecked: false, users: allUsers, selectedUsersForReassignment: []})
	// 	} else {
	// 		var total = [];
	// 		for(var j in allUsers) {
	// 			allUsers[j].checkedVal = true;
	// 			total.push(allUsers[j].naturalId);
	// 		}
	// 		this.setState({allChecked: true, users: allUsers, selectedUsersForReassignment: total})
	// 	}
	// }

	//<!------------------------------------- Whether user needs equipment -------------------------------------!>
	handleUserEquipmentSelection(user) {
		var selectedUsersForAssignment = this.state.selectedUsersForAssignment;
		//var crt = user.needsEquipmentForJob;
		for (let i in selectedUsersForAssignment) {
			if (selectedUsersForAssignment[i].userId === user.naturalId) {
				//selectedUsersForAssignment[i].needsEquipmentForJob = !crt;
				break;
			}
		}
		//user.needsEquipmentForJob = !crt;
		this.setState({ selectedUsersForAssignment: selectedUsersForAssignment });
	}

	//<!------------------------------------- Selecting a user for assigment -------------------------------------!>
	handleUserSelection(user) {
		var selectedUsersForAssignment = this.state.selectedUsersForAssignment;
		if (user.isSelected) {
			user.isSelected = false;
			// user.needsEquipmentForJob = false;
			for (let i in selectedUsersForAssignment) {
				if (selectedUsersForAssignment[i].userId === user.naturalId) {
					selectedUsersForAssignment.splice(i, 1);
					break;
				}
			}
		} else {
			user.isSelected = true;
			selectedUsersForAssignment.push({
				userId: user.naturalId
				// needsEquipmentForJob: false
			});
		}
		this.setState({ selectedUsersForAssignment: selectedUsersForAssignment });
	}

	//<!------------------------------------- Retry Again -------------------------------------!>
	retryAgain() {
		if (this.state.creationActivity.activityType === "IMR_CREATION") {
			this.setState({ jobCreated: false, creationActivity: null });
		} else if (this.state.creationActivity.activityType === "JOB_CREATION") {
			var oldActivity = this.state.creationActivity;
			this.setState({ oldJobActivity: oldActivity });
			this.setState({ jobCreated: false, creationActivity: null, selectUsersOption: true });
		}
	}

	assignmentComplete() {
		var users = this.state.users;
		for (let i in users) {
			//users[i].needsEquipmentForJob = false;
			users[i].isSelected = false;
			users[i].checkedVal = false;
		}
		this.setState({ jobCreated: false, creationActivity: null, selectedUsersForAssignment: [], users: users, selectedUsersForReassignment: [] });
		this.dateSelected();
	}

	//<!------------------------------------- Enabling user selection on Screen -------------------------------------!>
	selectUsersToAssign = () => {
		var oldActivity = this.state.creationActivity;
		this.setState({ oldJobActivity: oldActivity });
		this.setState({ selectUsersOption: true, creationActivity: null });
	}



	customerGroupSelected = (val) => {
		this.setState({ selectedCustomerGroup: val }, function () {
			this.dateSelected();
		});
	}

	productTypesSelected = (val) => {
		this.setState({ selectedProductTypes: val }, function () {
			this.dateSelected();
		})
	}

	equipmentTypeSelected = (val) => {
		this.setState({ selectedEquipmentType: val }, function () {
			this.dateSelected();
		})
	}

	spaceTypeSelected = (val) => {
		this.setState({ selectedSpaceType: val }, function () {
			this.dateSelected();
		})
	}


	addNewSlot() {
		this.setState({ addedNewSlot: true });
	}

	cancelCurrentSlot() {
		this.setState({ addedNewSlot: false });
	}

	changeUsers = (showAllUsers) => {
		this.setState({ showAllUsers: !showAllUsers });
		this.fetchUser(!showAllUsers);
	}

	//<!------------------------------------- Reassignment DIALOGE Render Method (UI Render)-------------------------------------!>
	// reassignmentDialog() {
	// 	return (
	// 		<div>
	// 		<Dialog open={this.state.reassignmentOpen} onClose={this.reassignmentDialogClose} maxWidth="sm" fullWidth={true} onEntering={this.handleEntering} aria-labelledby="confirmation-dialog-title">
	// 			{this.reassignJobBoxRender()}
	// 		</Dialog>
	// 		</div>
	// 	);
	// }

	// reassignmentConfirmationDialog() {
	// 	return (
	// 		<div>
	// 		<Dialog open={this.state.reassignmentConfirmation} onClose={this.reassignmentConfirmationClose} maxWidth="sm" onEntering={this.handleEntering} aria-labelledby="confirmation-dialog-title">
	// 			<div style={{padding: '30px', width: '400px', textAlign:'center'}}>
	// 				<div style={{fontSize: '16px', lineHeight: '32px', fontWeight: '500'}}>
	// 					<div>The list won't be edited later.</div>
	// 					<div>Are you sure you want to proceed?</div>
	// 				</div>
	// 				<div className="row" style={{marginTop:'30px'}}>
	// 					<div className="col-md-6">
	// 						<button className="btn btn-default" onClick={this.reassignmentConfirmationClose}>Cancel</button>
	// 					</div>
	// 					<div className="col-md-6">
	// 						<button className="btn btn-jt-primary" onClick={this.proceedReassignment}>Proceed</button>
	// 					</div>
	// 				</div>
	// 			</div>
	// 		</Dialog>
	// 		</div>
	// 	);
	// }

	//<!------------------------------------- Showing all users for Reassignment (UI Render)-------------------------------------!>
	// getAllUsersToSelect() {
	// 	var user;
	// 	//this.state.users.sort(function(a,b) {return (a.displayName > b.displayName) ? 1 : ((b.displayName > a.displayName) ? -1 : 0);} );
	// 	user = this.state.users.map((hero, index) => {
	// 		if(hero.checkedVal === undefined) {
	// 			hero.checkedVal = false;
	// 		}
	// 		return(
	// 			<div className="fc-heroe-pick" key={index}>
	// 				<div className="row">
	// 					<div className="col-md-1 col-sm-1 col-xs-2">
	// 						<Checkbox checked={hero.checkedVal} onChange={() => {this.handleHeroCheckBox(hero)}} value={hero.naturalId} classes={{root:'cstmCheckBox',checked:'greenChecked'}}/>
	// 					</div>
	// 					<div className="col-md-11 col-sm-11 col-xs-10">
	// 						<div>{hero.displayName} <span style={{opacity:'0.7'}}>({hero.phoneNumber})</span> {hero.naturalId}</div>
	// 					</div>
	// 				</div>
	// 			</div>
	// 		);
	// 	});
	// 	return user;
	// }

	//<!------------------------------------- Reassignment BOX Render Method (UI Render)-------------------------------------!>
	// reassignJobBoxRender() {
	// 	var totalSelcted = this.state.selectedUsersForReassignment.length;
	// 	return(
	// 		<div>
	// 			<div style={{position:'sticky',top:'0',padding:'30px 30px 20px 30px', backgroundColor:'#fff', boxShadow:'0px 0px 10px 0px', zIndex:'5'}}>
	// 				<div className="row">
	// 					<div className="col-md-5">
	// 						<div style={{fontSize:'16px',fontWeight:'bold'}}>Reassignment {this.props.itemType}</div>
	// 						<div>
	// 							<span style={{opacity:'0.6'}}>Delivery Date:</span> {this.state.selectedDate ? this.state.selectedDate.deliveryDate: null}
	// 						</div>
	// 					</div>
	// 					<div className="col-md-3 centralized">
	// 						<div style={{opacity:'0.6'}}> Selected Users </div>
	// 						<div>{totalSelcted}</div>
	// 					</div>
	// 					<div className="col-md-4">
	// 						{(this.state.reassignmentLoading)?
	// 							<CircularProgress style={{ color:'#000' }} size={29} thickness={3} />:null
	// 						}
	// 						<button className={"pull-right btn "+((totalSelcted > 0 ) ? "btn-jt-green-out":"btn-default no-rad")} disabled={totalSelcted === 0 ? true : false} onClick={this.askForReassignmentConfirmation}> Reassign Job </button>
	// 					</div>
	// 				</div>
	// 			</div>
	// 			<div style={{padding: '0 30px 30px 30px'}}>
	// 				<div>
	// 					<div className="fc-heroe-pick">
	// 						<div className="row">
	// 							<div className="col-md-1 col-sm-1 col-xs-2">
	// 								<Checkbox checked={this.state.allChecked} onChange={() => {this.handleAllCheck()}} value={"naturalId"} classes={{root:'cstmCheckBox',checked:'greenChecked'}}/>
	// 							</div>
	// 							<div className="col-md-11 col-sm-11 col-xs-10">
	// 								<div>Select All FC Users</div>
	// 							</div>
	// 						</div>
	// 					</div>
	// 					{this.getAllUsersToSelect()}
	// 				</div>
	// 			</div>
	// 		</div>
	// 	)
	// }

	//<!------------------------------------- Reassignment Render Method (UI Render)-------------------------------------!>
	// reassignMentRender() {
	// 	var reassign;
	// 	if(this.state.generatedSlots && this.state.generatedSlots.length > 0) {
	// 		reassign = <div className="top-twenty">
	// 				<div className="putaway-product">
	// 					<div className="row">
	// 						<div className="col-xs-7 col-sm-8 col-md-8">
	// 							<div className="pick-slot-name">Pending Jobs</div>
	// 						</div>
	// 						<div className="col-xs-5 col-sm-4 col-md-4">
	// 							<div className="generated-slot"><button className="btn btn-jt-primary" onClick={this.openReassignment}> Reassign Jobs </button></div>
	// 						</div>
	// 					</div>
	// 				</div>
	// 			</div>
	// 	}
	// 	return reassign;
	// }

	//<!------------------------------------- Generated Slots Data Render Method (UI Render)-------------------------------------!>
	generatedSlotsRender() {
		var slotsData;
		if (this.state.generatedSlots) {
			slotsData = this.state.generatedSlots.map((slot, index) => {
				return (<div className="top-twenty" key={index}>
					<div className="putaway-product">
						<div className="row">
							<div className="col-xs-7 col-sm-8 col-md-8">
								<div className="pick-slot-name">Slot {slot.slotId} <span style={{ opacity: '0.6', marginLeft: '10px' }}>({slot.jobActivityId})</span></div>
							</div>
							<div className="col-xs-5 col-sm-4 col-md-4">
								<div className="generated-slot"> {slot.activityStatus}</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-7">
								<div className="row">
									<div className="col-xs-3 col-sm-3 col-md-3">
										<div className="putaway-product-label">Delivery Date</div>
										<div className="putaway-product-value">{datefor.format(slot.deliveryDay)}</div>
									</div>
									<div className="col-xs-3 col-sm-3 col-md-3">
										<div className="putaway-product-label">Customer Group</div>
										<div className="putaway-product-value">{slot.customerType}</div>
									</div>
									{(slot.productType) ?
										<div className="col-xs-3 col-sm-3 col-md-3">
											<div className="putaway-product-label">Type of Goods</div>
											<div className="putaway-product-value">{slot.productType}</div>
										</div> : null
									}
									<div className="col-xs-3 col-sm-3 col-md-3">
										<div className="putaway-product-label">Pick By</div>
										<div className="putaway-product-value">{slot.equipmentType}</div>
									</div>
								</div>
							</div>
							<div className="col-md-5">
							</div>
						</div>
					</div>
				</div>)
			})
		}
		return slotsData;
	}

	//<!------------------------------------- Showing all users for selection (UI Render)-------------------------------------!>
	selectUsers() {
		var users = this.state.users.map((user, index) => {
			if (user.isSelected === undefined) {
				user.isSelected = false;
				//user.needsEquipmentForJob = false;
			}
			return (
				<div className="pick-user" key={index}>
					<div className="row">
						<div className="col-md-1">
							<Checkbox checked={user.isSelected} onChange={() => this.handleUserSelection(user)} value="checkedA" classes={{ root: 'cstmCheckBox', checked: 'greenChecked' }} />
						</div>
						<div className="col-md-7">
							{user.displayName} <span style={{ color: '#808080' }}>({user.phoneNumber}) | {user.naturalId}</span>
						</div>
						<div className="col-md-4">
							{
								// <Checkbox checked={user.needsEquipmentForJob} onChange={() => this.handleUserEquipmentSelection(user)}  value="checkedA" classes={{root:'cstmCheckBox',checked:'greenChecked'}} disabled={user.isSelected?false:true}/>
							}
						</div>
					</div>
				</div>
			);
		})
		return users;
	}

	render() {
		const { showAllUsers, loadFetchUsers } = this.state;
		return (
			<div style={{ position: 'relative' }}>
				{(!this.props.selectedDate) ?
					<div className="blocked-selection-box"></div> : null
				}
				<div className="putaway-pallet-outer">
					<div className="row pick-name-holder">
						<div className="col-xs-5 col-sm-7 col-md-5">
							<div className="pick-item-label">{this.props.itemType}</div>
						</div>
						<div className="col-sm-1 col-md-1 hidden-xs">
							{
								// (this.state.showloader)?
								// <CircularProgress style={{ color:'#000' }} size={29} thickness={3} />:null
							}
						</div>
						<div className="col-xs-7 col-sm-3 col-md-3" style={{ lineHeight: '34px', textAlign: 'right' }}>
							{
								// <Checkbox checked={this.state.priority} onChange={this.handlePriority} value="checkedG" classes={{root:'cstmCheckBox',checked:'greenChecked'}}/> Priority Customer
							}
						</div>
						<div className="col-xs-12 col-sm-4 col-md-3" style={{ textAlign: 'right' }}>
							{
								// <DateSelector dates={this.dates()} selected={this.state.selectedDate} classes={'pull-right'} dateSelected={this.dateSelected}/>
								(this.state.showloader) ?
									<CircularProgress style={{ color: '#000' }} size={23} thickness={3} /> : null
							}
						</div>
					</div>
					<div className="pick-name-holder">
						<div className="top-twenty">
							<div className="row">
								<div className="col-md-10">
									<div className="row">
										<div className="col-md-3">
											{
												(this.state.addedNewSlot && (!this.state.creationActivity || (this.state.creationActivity && this.state.creationActivity.activityStatus !== 'FAILED'))) ? <div className="blocked-selection-box" style={{ margin: '0 15px' }}></div> : null
											}
											{
												//<NewDropSelector options={this.props.customerGroup} selected={this.state.selectedCustomerGroup} selctionChange={this.customerGroupSelected} type={'Customer Group'}/>
											}
											<ExpDropSelector options={this.props.customerGroup} selected={this.state.selectedCustomerGroup} classes={{ drop: 'pick-type-drop' }} selctionChange={this.customerGroupSelected} type={'Customer Group'} />

										</div>
										{(this.props.productTypes) ?
											<div className="col-md-3" >
												{
													(this.state.addedNewSlot && (!this.state.creationActivity || (this.state.creationActivity && this.state.creationActivity.activityStatus !== 'FAILED'))) ? <div className="blocked-selection-box" style={{ margin: '0 15px' }}></div> : null
												}
												{
													//<NewDropSelector options={this.props.productTypes} selected={this.state.selectedProductTypes} selctionChange={this.productTypesSelected} type={'Type Of Goods'}/>
												}
												<ExpDropSelector options={this.props.productTypes} selected={this.state.selectedProductTypes} classes={{ drop: 'pick-type-drop' }} selctionChange={this.productTypesSelected} type={'Type Of Goods'} />

											</div> : null
										}
										<div className="col-md-3">
											{
												(this.state.addedNewSlot && (!this.state.creationActivity || (this.state.creationActivity && this.state.creationActivity.activityStatus !== 'FAILED'))) ? <div className="blocked-selection-box" style={{ margin: '0 15px' }}></div> : null
											}
											{
												//<NewDropSelector options={this.props.equipmentType} selected={this.state.selectedEquipmentType} selctionChange={this.equipmentTypeSelected} type={'Equipment Type'}/>
											}
											<ExpDropSelector options={this.props.equipmentType} selected={this.state.selectedEquipmentType} classes={{ drop: 'pick-type-drop' }} selctionChange={this.equipmentTypeSelected} type={'Equipment Type'} />
										</div>
										{(this.props.spaceTypes && this.props.spaceTypes.length > 0) ?
											<div className="col-md-3">
												{
													(this.state.addedNewSlot && (!this.state.creationActivity || (this.state.creationActivity && this.state.creationActivity.activityStatus !== 'FAILED'))) ? <div className="blocked-selection-box" style={{ margin: '0 15px' }}></div> : null
												}
												{
													//<NewDropSelector options={this.props.spaceTypes} selected={this.state.selectedSpaceType} selctionChange={this.spaceTypeSelected} type={'Space Type'} value={'spaceDisplayName'}/>
												}
												<ExpDropSelector options={this.props.spaceTypes} selected={this.state.selectedSpaceType} classes={{ drop: 'pick-type-drop' }} selctionChange={this.spaceTypeSelected} type={'Space Type'} value={'spaceDisplayName'} />
											</div> : null
										}
									</div>
								</div>
								<div className="col-md-2">
									<button className={"btn pull-right " + ((this.state.canAddNewSlot && !this.state.addedNewSlot && !this.state.showloader) ? "btn-jt-green-out" : "btn-default no-rad")} disabled={!this.state.canAddNewSlot || this.state.addedNewSlot || this.state.showloader} onClick={this.addNewSlot}>Create Slot</button>
								</div>
							</div>
						</div>
					</div>
					<div className="pick-name-holder">
						<div className="generated">
							{
								//this.reassignMentRender()
							}
							{this.generatedSlotsRender()}
						</div>
						{(this.state.addedNewSlot) ?
							<div className="top-twenty">
								<div className="putaway-product">
									<div className="row">
										<div className="col-xs-3 col-sm-3 col-md-4">
											<div className="pick-slot-name">Slot {this.state.currentSlot}</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-7">
											<div className="row">
												<div className="col-xs-3 col-sm-3 col-md-3">
													<div className="putaway-product-label">Delivery Date</div>
													<div className="putaway-product-value">{(this.props.selectedDate) ? this.props.selectedDate.deliveryDate : "--/--/----"}</div>
												</div>
												<div className="col-xs-3 col-sm-3 col-md-3">
													<div className="putaway-product-label">Customer Group</div>
													<div className="putaway-product-value">{this.state.selectedCustomerGroup}</div>
												</div>
												{(this.props.productTypes) ?
													<div className="col-xs-3 col-sm-3 col-md-3">
														<div className="putaway-product-label">Type of Goods</div>
														<div className="putaway-product-value">{this.state.selectedProductTypes}</div>
													</div> : null
												}
												<div className="col-xs-3 col-sm-3 col-md-3">
													<div className="putaway-product-label">Pick By</div>
													<div className="putaway-product-value">{this.state.selectedEquipmentType}</div>
												</div>
											</div>
										</div>
										<div className="col-md-1">
										</div>
										<div className="col-md-2">
											{(!this.state.jobCreated) ?
												<button className="btn btn-jt-cancel-gr no-rad ful-wide" onClick={this.cancelCurrentSlot}> Cancel Slot </button> : null
											}
										</div>
										<div className="col-md-2" style={{ textAlign: 'right', paddingLeft: 0 }}>
											<button className={"btn " + ((this.state.selectedDate && !this.state.jobCreated) ? "btn-jt-green-out" : "btn-default no-rad")} disabled={(this.state.selectedDate && !this.state.jobCreated) ? false : true} onClick={this.createJobRequest}> Create Job Request </button>
										</div>
										{
											// <div className="col-xs-3 col-sm-1 col-md-1">
											// 	{(this.state.createPickLoader)?<CircularProgress style={{ color:'#58a159' }} size={29} thickness={3} />:null}
											// </div>
											// <div className="col-xs-9 col-sm-4 col-md-4 right-pull-xs">
											// 	<button className={"btn "+((this.state.selectedDate && !this.state.jobCreated) ? "btn-jt-green-out":"btn-default no-rad")} disabled={(this.state.selectedDate && !this.state.jobCreated)? false :true} onClick={this.createJobRequest}> Create Job Request </button>
											// </div>
										}
									</div>

									{(this.state.selectUsersOption) ?
										<div style={{ marginTop: '15px' }}>
											<div className="row">
												<div className="col-md-8" style={{ fontSize: '16px' }}>
													Select FC Heroes to assign jobs
												</div>
												<div className="col-md-4">
													{
														// Need Equipment
													}
												</div>
											</div>
											<div style={{ fontSize: '13px', color: 'gray', marginTop: '5px' }}>
												<Checkbox checked={showAllUsers} onChange={(e) => { this.changeUsers(showAllUsers) }} classes={{ root: 'cstmCheckBox', checked: 'greenChecked' }} /> <span style={{ marginRight: '5px' }}>Show All Users</span>
												{loadFetchUsers ? <CircularProgress style={{ color: '#000' }} size={15} thickness={3} /> : null}
											</div>
										</div> : null
									}
								</div>
							</div> : null
						}

						{//User selection for job assignment
							(this.state.selectUsersOption) ?
								<div>
									<div style={{ maxHeight: '400px', overflow: 'scroll', padding: '0 15px', boxShadow: '0 5px 6px 2px rgba(182, 182, 182, 0.5)' }}>
										{this.selectUsers()}

									</div>
									<div style={{ marginTop: '15px', textAlign: 'right' }}>
										<div className="row">
											<div className="col-md-9">
												{(this.state.jobsAssigningLoader) ?
													<CircularProgress style={{ color: '#000' }} size={29} thickness={3} /> : null
												}
											</div>
											<div className="col-md-3">
												<button className={"btn " + ((this.state.selectedUsersForAssignment.length > 0) ? "btn-jt-green-out" : "btn-default no-rad")} disabled={(this.state.selectedUsersForAssignment.length > 0) ? false : true} onClick={this.assignJobs}>Assign Jobs </button>
											</div>
										</div>
									</div>
								</div> : null
						}
						{(this.state.jobCreated && this.state.creationActivity) ?
							<div className="top-twenty">
								<div className="row">
									<div className="col-md-6">
										<span className="opacity-text">Activity Id:</span> {this.state.creationActivity.jobActivityId}
									</div>
									<div className="col-md-6" style={{ textAlign: 'right' }}>
										{(this.state.checkingStatus) ?
											<CircularProgress style={{ color: '#000' }} size={24} thickness={3} /> : null
										}
										{(this.state.creationActivity.activityStatus === 'FAILED') ?
											<button className="btn btn-default" style={{ marginRight: '5px', outline: 'none' }} onClick={this.retryAgain}> Retry Again </button> : null

										}
										{(this.state.creationActivity.activityStatus !== 'GENERATED') ?
											<button className={"btn btn-jt-primary " + (this.state.checkStatusDisabled ? "disabled-btn" : "")} disabled={this.state.checkStatusDisabled} onClick={this.checkActivityStatus}> Check Status </button>
											: ((this.state.creationActivity.activityType === 'IMR_CREATION') ?
												<button className="btn btn-jt-primary" onClick={this.selectUsersToAssign}> Select Users for Assing Jobs</button>
												:
												<button className="btn btn-jt-primary" onClick={this.assignmentComplete}> Reload Page</button>
											)
										}
									</div>
								</div>
								<div>
									<div>Response:</div>
									<div>{this.getLogsRender()}</div>
								</div>
							</div> : null
						}
					</div>
					{
						// {this.reassignmentDialog()}
						// {this.reassignmentConfirmationDialog()}
					}
				</div>
				{(this.state.error) ?
					<ErrorBox errorText={this.state.error} closeError={this.closeError} /> : null
				}
				{
					// {(this.state.showReassignSuccessScreen)?
					//  	<div className="randomErrorBox">
					//    	<div className="errorContianer" style={{width:'300px', textAlign: 'center', color: '#58a159', fontWeight: 'bold'}}>
					//      	<div><img src={Tick} alt="success-img" style={{width:'65px', height: '65px'}}/></div>
					//      	<div className="top-twenty">Reassignment Done Successfully</div>
					//      	<div className="top-twenty"><button className="btn btn-jt-green" onClick={this.closeSuccessScreen}>Okay</button></div>
					//    	</div>
					//  	</div>:null
					// }
				}
			</div>
		);
	}

}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/Commons/ItemWisePick.js